var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotaLogoWhite1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V65.5H65.5V0ZM61.861,61.861H3.639V3.639H61.861Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.253,62.748l-3.72-12.13h-.081l-3.881,12.13H42.8L49.754,45.2h3.4l6.873,17.548Z",
    transform: "translate(-8.19 -8.649)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.252,62.748V49.162H16.4V45.2H30.47v3.962H25.619V62.748Z",
    transform: "translate(-3.138 -8.649)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.357,13.7a8.889,8.889,0,0,0-7.278,3.558A7.646,7.646,0,0,0,42.947,19.2a11.6,11.6,0,0,0-.647,3.72h0a8.836,8.836,0,0,0,9.057,8.814h.4a9.033,9.033,0,0,0,8.733-9.3A8.939,8.939,0,0,0,51.357,13.7Zm.081,14.151c-2.83,0-4.771-2.426-4.771-5.256a4.891,4.891,0,0,1,4.69-5.094c2.83,0,4.69,2.426,4.69,5.175C56.047,25.343,54.187,27.85,51.438,27.85Z",
    transform: "translate(-8.094 -2.62)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.419,31.548l-4.69-7.52h-.081v7.52H16.2V14h4.448v7.925h.081L25.58,14H30.19l-5.741,8.733,6.065,8.814Z",
    transform: "translate(-3.1 -2.679)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotaLogoWhite1);
export default __webpack_public_path__ + "static/media/Kota_logo_white-1.912d140267a017b6ac094e3d950404b1.svg";
export { ForwardRef as ReactComponent };